import {StyleSheet} from 'react-native';
import {random} from 'lodash';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  header: {
    marginTop: indent * 1.5,
    marginBottom: indent,
    flexDirection: 'row',
  },
  headerText: {
    marginTop: indent,
    height: 20,
    width: `${random(30, 60)}%`,
    paddingLeft: indent * 0.8,
    justifyContent: 'center',
  },
  nameContainer: {
    flexDirection: 'row',
  },
  firstName: {
    height: 20,
    width: `${random(40, 70)}%`,
  },
  lastName: {
    height: 20,
    marginLeft: indent * 0.3,
    width: `${random(40, 70)}%`,
  },
  progress: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: indent * 0.5,
  },
  progressBarContainer: {
    width: 60,
    marginRight: indent * 0.5,
  },
  activationDate: {
    marginTop: indent * 0.3,
    height: 14,
    width: `${random(60, 100)}%`,
  },
  progressBar: {
    width: 60,
    height: 6,
  },
  progressBarPercent: {
    marginLeft: indent * 0.5,
    width: 161,
    height: 14,
  },
  avatar: {
    width: 56,
    height: 56,
    borderRadius: 50,
  },
});
